export function showModal(id, args) {
  return {
    type: 'unmodal/open',
    payload: {
      id: id,
      args: args
    }
  };
}
export function hideModal(id) {
  return {
    type: 'unmodal/close',
    payload: {
      id: id
    }
  };
}
export function removeModal(id) {
  return {
    type: 'unmodal/remove',
    payload: {
      id: id
    }
  };
}